import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  page: 1,
  limit: 10,
};
const accountSlice = createSlice({
  name: "accountList",
  initialState,
  reducers: {
    setFilterType: (state, action) => {
      state.filterType = {
        ...state.filterType,
        ...action.payload,
      };
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },

    clearFilter: (state) => {
      state.page = 1;
      state.limit = 10;
    },
  },
});

export const { setPage, setLimit, clearFilter } = accountSlice.actions;
export default accountSlice.reducer;
